import _ from 'lodash';

export default function formatAsUpperFirst(text: string) {
	return _(text)
		.split(' ')
		.compact()
		.map(_.toLower)
		.map(_.upperFirst)
		.join(' ');
}
